// extracted by mini-css-extract-plugin
export default {"footerText":"FlexFooter_footerText__ncoUb","flexFooter":"FlexFooter_flexFooter__PW5MB","footerPadding":"FlexFooter_footerPadding__FpYrh","navItem":"FlexFooter_navItem__9Uxk3"};